import { useEffect, useState } from "react";
import { sql, getObjetivoEspecifico } from "../componentes/api.js";
import AlertTitle from "@mui/material/AlertTitle";
import Alert from "@mui/material/Alert";
import SegBeneficiario from "./SegBeneficiario.jsx";

const Seguimiento = (props) => {
  const [objetivo, setObjetivo] = useState("");
  const [beneficiarios, setBeneficiarios] = useState([]);
  const [idBeneficiario, setIdBeneficiario] = useState("");
  const [verActividades, setVerActividades] = useState(false);
  const [conexiones, setConexiones] = useState({
    NumIngresos: 0,
    HoraIngreso: "",
    HoraFinal: "",
  });

  useEffect(() => {
    const cargarObjetivos = async () => {
      try {
        /**** Carga el Objetivo específico del Proyecto ***/
        const response = await getObjetivoEspecifico(props.idProyecto);
        setObjetivo(response.data.ObjetivoEspecifico);
      } catch (error) {
        props.mostrarMsg([
          "ERROR",
          "Ocurrio un error al cargar el Objetivo del Proyecto ",
          error,
        ]);
      }
    };

    const cargarBeneficiarios = async () => {
      try {
        const response = await sql("getParticipantes", "POST", {
          idProyecto: props.idProyecto,
          idAuditor: props.id,
          tipoParticipante: props.tipoParticipante,
        });
        if (response.legth !== 0 && response.legth !== "0") {
          setBeneficiarios(response);
        } else {
          setBeneficiarios([]);
        }
      } catch (error) {
        props.mostrarMsg([
          "ERROR",
          "Ocurrio un error al cargar los Beneficiarios",
          error,
        ]);
      }
    };

    cargarObjetivos();
    cargarBeneficiarios();
  }, [props.idProyecto]);

  const asignarDato = (event) => {
    event.preventDefault();
    setIdBeneficiario(event.target.value);
    setVerActividades(true);
    buscarConexiones(event.target.value);
  };

  const buscarConexiones = async (beneficiario) => {
    /*** Primero busco cuando fue su última conexión y cuantas ha realizado ***/
    try {
      const con = await sql("getConexiones", "POST", { Id: beneficiario });
      setConexiones(con[0]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar la información de las conexiones del beneficiario",
        error,
      ]);
    }
  };

  return (
    <div className="container-fluid card shadow mt-2">
      <div className="row">
        <Alert severity="info">
          <AlertTitle>
            <strong>OBJETIVO ESPECIFICO DEL PROYECTO</strong>
          </AlertTitle>
          {objetivo || "Seleccione un Proyecto para ver el Objetivo"}
        </Alert>
      </div>

      <div className="row mt-3 mx-0">
        <div className="row form-floating mb-3">
          <div className="col-sm-6">
            <label htmlFor="idBeneficirio">Participante (Beneficiario)</label>
            <select
              type="text"
              className="form-control"
              name="idBeneficiario"
              value={idBeneficiario}
              onChange={(event) => {
                asignarDato(event);
              }}
            >
              <option key="0" value="0">
                Por favor seleccione un Beneficiario...
              </option>
              {beneficiarios.map((reg, i) => {
                return (
                  <option key={i} value={reg.Id} label={reg.Nbres}>
                    {" "}
                    {reg.Nbres}{" "}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="col-sm-6">
            <div className="shadow-lg p-3 mb-2 bg-body-tertiary rounded">
              <div>
                Ultima conexión: <strong>{conexiones.HoraFinal}</strong>
              </div>
              <div>
                Número total de conexiones:{" "}
                <strong>{conexiones.NumIngresos}</strong>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      {verActividades === true && (
        <SegBeneficiario
          idUsuario={props.idUsuario}
          idProyecto={props.idProyecto}
          idBeneficiario={idBeneficiario}
        />
      )}
    </div>
  );
};

export default Seguimiento;
